module.exports = __webpack_public_path__ + "videos/hero_en.7e00ab2.mp4";